import { wrapPageElement as wrap } from './src/root-wrapper'

export const wrapPageElement = wrap
